import Collection from '~/pages/chat/models/collection';
import APIV5 from '~/models/api';
import KDate from '~/models/kdate';

/**
 * @type {Collection<string, string>}
 */
export default class RepresentationManager extends Collection {
	/**
	 * Create a representation cache
	 *
	 * @param $q
	 * @param $rootScope
	 */
	constructor($q, $rootScope) {
		super();
		this.$q = $q;
		this.$rootScope = $rootScope;
	}

	/**
	 * Fetch a representation
	 *
	 * @param {string} kid
	 * @returns {Promise<*>}
	 */
	async fetch(kid) {
		if (this.has(kid)) {
			// console.log(`fake fetching ${kid}`);
			return this.get(kid);
		}
		// console.log(`real fetching ${kid} done`);

		const elements = await APIV5
			.instance.objectRepreGet({
				items: [kid],
				mode: 'simple',
				kparam: {
					module: 'chat',
					kdate: KDate.now().asString(),
				},
			}, { id: 'representation-manager.fetch' });
		this.set(kid, elements.result[kid]);
		return this.get(kid);
	}

	async fetchAll() {
		const toFetch = [];

		for (const [key, value] of this.entries()) {
			if (key === value) {
				toFetch.push(value);
			}
		}

		const elements = await APIV5
			.instance.objectRepreGet({
				items: toFetch,
				mode: 'simple',
				kparam: {
					module: 'chat',
					kdate: KDate.now().asString(),
				},
			}, { id: 'representation-manager.fetch-all' });

		for (const [key, value] of Object.entries(elements.result)) {
			this.set(key, value);
		}

		return elements.result;
	}
}
